export default __webpack_public_path__ + "static/media/rising-pops.7eda816b.mp3";